'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Immutable = require('Immutable');

var _LinkCustomParams = require('MeetingsBase/models/LinkCustomParams');

var _LinkCustomParams2 = _interopRequireDefault(_LinkCustomParams);

var _UserBusyTimes = require('MeetingsBase/models/UserBusyTimes');

var _UserBusyTimes2 = _interopRequireDefault(_UserBusyTimes);

var _MeetingsUser = require('MeetingsBase/models/MeetingsUser');

var _MeetingsUser2 = _interopRequireDefault(_MeetingsUser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaults = {
  allUsersBusyTimes: (0, _Immutable.List)(),
  bufferTime: 0,
  integration: null,
  customParams: new _LinkCustomParams2.default(),
  linkId: null,
  linkType: null,
  offline: false,
  openGates: (0, _Immutable.List)(),
  ownerPrioritized: null,
  inactive: false,
  formGuid: null,
  contentTracking: null,
  isUnGatedForFifteenMinuteStartTimes: false,
  meetingsUserBlob: new _MeetingsUser2.default()
};

var PublicAvailabilityInfo = function (_Record) {
  _inherits(PublicAvailabilityInfo, _Record);

  function PublicAvailabilityInfo() {
    _classCallCheck(this, PublicAvailabilityInfo);

    return _possibleConstructorReturn(this, (PublicAvailabilityInfo.__proto__ || Object.getPrototypeOf(PublicAvailabilityInfo)).apply(this, arguments));
  }

  _createClass(PublicAvailabilityInfo, [{
    key: 'updateBusyTime',
    value: function updateBusyTime(jsonUserBusyTimes) {
      var updatedUserBusyTimes = _UserBusyTimes2.default.from(jsonUserBusyTimes);
      return this.update('allUsersBusyTimes', function (allUsersBusyTimes) {
        return allUsersBusyTimes.map(function (userBusyTimes) {
          if (userBusyTimes.id === updatedUserBusyTimes.id) {
            return updatedUserBusyTimes;
          }

          return userBusyTimes;
        });
      });
    }
  }], [{
    key: 'from',
    value: function from(json) {
      var customParams = _LinkCustomParams2.default.from(json.customParams);
      var allUsersBusyTimes = (0, _Immutable.List)(json.allUsersBusyTimes.map(function (userBusyTimes) {
        return _UserBusyTimes2.default.from(userBusyTimes);
      }));
      return new PublicAvailabilityInfo({
        allUsersBusyTimes: allUsersBusyTimes,
        bufferTime: customParams.meetingBufferTime,
        linkId: json.linkId,
        linkType: json.linkType,
        integration: json.meetingsUserBlob.calendarSettings.provider,
        customParams: customParams,
        meetingsUserBlob: _MeetingsUser2.default.from(json),
        offline: json.offline,
        openGates: (0, _Immutable.List)(json.openGates),
        ownerPrioritized: json.customParams.ownerPrioritized,
        inactive: json.inactive,
        formGuid: json.formGuid,
        contentTracking: json.contentTracking,
        isUnGatedForFifteenMinuteStartTimes: json.isUnGatedForFifteenMinuteStartTimes
      });
    }
  }]);

  return PublicAvailabilityInfo;
}((0, _Immutable.Record)(defaults));

exports.default = PublicAvailabilityInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/models/PublicAvailabilityInfo.js
// module id = 194
// module chunks = 0